export const LeftMenuData = (location, user) => {
  if (location.pathname.match("HUBExperience")) {
    return [
      {
        id: 1,
        title: "Company Set Up",
        pathName: "/HUBExperience/companysetup",
      },
      {
        id: 2,
        title: "Medical Plan Set Up",
        pathName: "/HUBExperience/medicalplansetup",
      },
      {
        id: 3,
        title: "Medical Credentials",
        pathName: "/HUBExperience/medicalcredentials",
      },
      {
        id: 4,
        title: "Dental Plan Set Up",
        pathName: "/HUBExperience/dentalplansetup",
      },
      {
        id: 5,
        title: "Vision Plan Set Up",
        pathName: "/HUBExperience/visionplansetup",
      },
      {
        id: 6,
        title: "Rebates & Reimbursements",
        pathName: "/HUBExperience/rebatesandreimbursements",
      },
      {
        id: 7,
        title: "Import Carrier file",
        pathName: "/HUBExperience/importcarrierfile",
      },
      // {
      //   id: 8,
      //   title: "Approved Carrier file",
      //   pathName: "/HUBExperience/approvecarrierfile",
      // },
    ];
  } else if (location.pathname.match("Admin")) {
    return [
      {
        id: 1,
        title: "Region Request",
        pathName: "/Admin/servicerequestview",
      },
      {
        id: 2,
        title: "User Details",
        pathName: "/Admin/userdetails",
      },
      {
        id: 3,
        title: "Carrier Details",
        pathName: "/Admin/carrier",
      },
    ];
  } else if (location.pathname.match("ACGHealthInsights")) {
    if (location.pathname.match("utilitydata")) {
      return [
        {
          id: 1,
          title: "CBSA",
          pathName: "/ACGHealthInsights/utilitydata/cbsa",
        },
        {
          id: 2,
          title: "MEDC Inflation",
          pathName: "/ACGHealthInsights/utilitydata/medci",
        },
        {
          id: 3,
          title: "MEDC by Gender",
          pathName: "/ACGHealthInsights/utilitydata/medcg",
        },
        {
          id: 4,
          title: "DRF",
          pathName: "/ACGHealthInsights/utilitydata/drf",
        },
        {
          id: 5,
          title: "LSRAF",
          pathName: "/ACGHealthInsights/utilitydata/lsraf",
        },
        {
          id: 6,
          title: "GEO",
          pathName: "/ACGHealthInsights/utilitydata/geo",
        },
        {
          id: 7,
          title: "COCI Inflation",
          pathName: "/ACGHealthInsights/utilitydata/coci",
        },
        {
          id: 8,
          title: "Industry Risk",
          pathName: "/ACGHealthInsights/utilitydata/indrisk",
        },
        {
          id: 9,
          title: "Insurance Carrier",
          pathName: "/ACGHealthInsights/utilitydata/insur",
        },
        {
          id: 10,
          title: "Funding Arrangement",
          pathName: "/ACGHealthInsights/utilitydata/funding",
        },
        {
          id: 11,
          title: "CBSA by Size & Plan",
          pathName: "/ACGHealthInsights/utilitydata/cbsasizeplan",
        },
        {
          id: 12,
          title: "Plan Var by Industry & CBSA",
          pathName: "/ACGHealthInsights/utilitydata/planvar",
        },
        {
          id: 13,
          title: "Tier",
          pathName: "/ACGHealthInsights/utilitydata/tier",
        },
        {
          id: 14,
          title: "UW Wellness Program",
          pathName: "/ACGHealthInsights/utilitydata/wellness",
        },
        {
          id: 15,
          title: "Large Claim(s) Assessment",
          pathName: "/ACGHealthInsights/utilitydata/largeclaim",
        },
        {
          id: 16,
          title: "UW Maternity Risk",
          pathName: "/ACGHealthInsights/utilitydata/maternity",
        },
        {
          id: 17,
          title: "RUBs",
          pathName: "/ACGHealthInsights/utilitydata/rubs",
        },
        {
          id: 18,
          title: "Condition Category",
          pathName: "/ACGHealthInsights/utilitydata/topconditions",
        },
        {
          id: 19,
          title: "ERUs",
          pathName: "/ACGHealthInsights/utilitydata/eru",
        },
        {
          id: 20,
          title: "UW Margin",
          pathName: "/ACGHealthInsights/utilitydata/uwmargin",
        },

        {
          id: 21,
          title: "Wellness Program",
          pathName: "/ACGHealthInsights/utilitydata/uwellness",
        },
        {
          id: 22,
          title: "Age Band / RUB",
          pathName: "/ACGHealthInsights/utilitydata/ageband",
        },
        {
          id: 23,
          title: "All Ranked Measure Data",
          pathName: "/ACGHealthInsights/utilitydata/rankedmeasuredata",
        },
        {
          id: 24,
          title: "Invalid ICD10/Zip Code",
          pathName: "/ACGHealthInsights/utilitydata/icd10zip",
        },
        {
          id: 25,
          title: "Track Import History",
          pathName: "/ACGHealthInsights/utilitydata/trackhistory",
        },
        {
          id: 26,
          title: "Salary Risk",
          pathName: "/ACGHealthInsights/utilitydata/salaryrisk",
        },
        {
          id: 27,
          title: "AgeSex Risk",
          pathName: "/ACGHealthInsights/utilitydata/agesexrisk",
        },
        {
          id: 28,
          title: "GDOR Master Detail",
          pathName: "/ACGHealthInsights/utilitydata/gdormasterdetail",
        },
      ];
    } else if (location.pathname.match("clientdata")) {
      return [
        {
          id: 1,
          title: "Client Detail",
          pathName: "/ACGHealthInsights/clientdata/clientdetail",
        },
        {
          id: 6,
          title: "Wellness Programs",
          pathName: "/ACGHealthInsights/clientdata/wellnessprograms",
        },
        {
          id: 2,
          title: "Import Census",
          pathName: "/ACGHealthInsights/clientdata/census",
        },
        {
          id: 3,
          title: "Large Claim(s)",
          pathName: "/ACGHealthInsights/clientdata/clientlargeclaim",
        },
        // {
        //   id: 4,
        //   title: "Large Claim PEPM",
        //   pathName: "/ACGHealthInsights/clientdata/largeclaimuw",
        // },
        // {
        //   id: 5,
        //   title: "Plan AV & Deviation",
        //   pathName: "/ACGHealthInsights/clientdata/planavdeviation",
        // },
        // {
        //   id: 7,
        //   title: "COBRA Participation",
        //   pathName: "/ACGHealthInsights/clientdata/cobrapartipation",
        // },
      ];
    } else if (location.pathname.match("importcensus")) {
      return [
        {
          id: 1,
          title: "Improt Census",
          pathName: "/ACGHealthInsights/importcensus",
        },
      ];
    } else if (location.pathname.match("report&extract")) {
      return [
        {
          id: 1,
          title: "Renewal Adjustment Percent by Plan",
          pathName: "/ACGHealthInsights/report&extract/renewaladj",
        },
        // {
        //   id: 2,
        //   title: "Underwriting Adjustments",
        //   pathName: "/ACGHealthInsights/report&extract/underwritingadj",
        // },
        // {
        //   id: 3,
        //   title: "Final ACG Rate Review-Review Only",
        //   pathName: "/ACGHealthInsights/report&extract/ratereview",
        // },
        // {
        //   id: 4,
        //   title: "Underwriting Output",
        //   pathName: "/ACGHealthInsights/report&extract/underwritingop",
        // },
        // {
        //   id: 5,
        //   title: "RUB Output",
        //   pathName: "/ACGHealthInsights/report&extract/clientrubs",
        // },
        {
          id: 6,
          title: "Download/Publish Reports",
          pathName: "/ACGHealthInsights/report&extract/rptexport",
        },
      ];
    } else {
      return [
        {
          id: 1,
          title: "Dashboard",
          pathName: "/ACGHealthInsights",
        },
      ];
    }
  } else if (location.pathname.match("servicerequest")) {
    let serviceArr = [
      {
        id: 1,
        title: "Region Request",
        pathName: "/servicerequest/regionrequest",
      },
    ];
    if (user?.UserRole === "Clinician") {
      return [
        ...serviceArr,
        {
          id: 3,
          title: "EmpoweRx Request",
          pathName: "/servicerequest/EmpoweRxRequest",
        },
      ];
    }
    if (user?.UserRole === "Pharmacy") {
      return [
        ...serviceArr,
        {
          id: 2,
          title: "SBAR Form Access",
          pathName: "/servicerequest/SBARrequest",
        },
        {
          id: 4,
          title: "SBAR Intake Request",
          pathName: "/servicerequest/SBARIntakerequest",
        },
        {
          id: 5,
          title: "Clinical Support",
          pathName: "/servicerequest/ClinicalSupport",
        },
        {
          id: 6,
          title: "Market Scan Management Request",
          pathName: "/servicerequest/MarketScanMgmtRequest",
        },
      ];
    } else {
      return [
        ...serviceArr,
        {
          id: 3,
          title: "EmpoweRx Request",
          pathName: "/servicerequest/EmpoweRxRequest",
        },
        {
          id: 2,
          title: "SBAR Form Access",
          pathName: "/servicerequest/SBARrequest",
        },
        {
          id: 4,
          title: "SBAR Intake Request",
          pathName: "/servicerequest/SBARIntakerequest",
        },
        {
          id: 5,
          title: "Clinical Support",
          pathName: "/servicerequest/ClinicalSupport",
        },
        user?.IsEmpoweRx === 1 && {
          id: 6,
          title: "Market Scan Management Request",
          pathName: "/servicerequest/MarketScanMgmtRequest",
        },
      ];
    }
  } else if (location.pathname.match("EmpoweRx")) {
    return user?.UserRole === "Client" && user.gpoId > 0
      ? [
          // {
          //   id: 1,
          //   title: "Market Scan",
          //   pathName: "/EmpoweRx/RxBlockPricingEx",
          // },
        ]
      : [
          {
            id: 1,
            title: "EmpoweRx RFP",
            pathName: "/EmpoweRx/EmpoweRxRFP",
            submenu: [
              {
                smId: 1,
                title: "Client Rx Information Baseline",
                pathName: "/EmpoweRx/EmpoweRxRFP/ClientRxInformationBaseline",
              },
              {
                smId: 2,
                title: "Specialty Drug",
                pathName: "/EmpoweRx/EmpoweRxRFP/SDL",
              },
              {
                smId: 3,
                title: "Pharmacy Marketing Request",
                pathName: "/EmpoweRx/EmpoweRxRFP/RFP",
              },
            ],
          },
          {
            id: 2,
            title: "Market Scan",
            pathName: "/EmpoweRx/RxBlockPricing",
            submenu: [
              {
                smId: 1,
                title: "Review Block Pricing",
                pathName: "/EmpoweRx/RxBlockPricing/ReviewBlockPricing",
              },
              (user?.UserRole === "Admin" ||
                user?.IsMarketScanManagementUserRights === 1) && {
                smId: 2,
                title: "Open Update Period",
                pathName: "/EmpoweRx/RxBlockPricing/OpenUpdatePeriod",
              },
            ],
          },
        ];
  } else if (location.pathname.match("clinicalIntake")) {
    if (user?.UserRole === "Pharmacy" || user?.UserRole === "Admin") {
      return [
        {
          id: 1,
          title: "SBAR Intake Request",
          pathName: "/clinicalIntake/SBARIntakeRequest",
        },
        {
          id: 2,
          title: "SBAR",
          pathName: "/clinicalIntake/SBAR",
        },
        {
          id: 3,
          title: "SBAR Data",
          pathName: "/clinicalIntake/SBARList",
        },
      ];
    } else {
      return [
        {
          id: 2,
          title: "SBAR",
          pathName: "/clinicalIntake/SBAR",
        },
        {
          id: 3,
          title: "SBAR Data",
          pathName: "/clinicalIntake/SBARList",
        },
      ];
    }
  } else if (location.pathname.match("planinsightsadmin")) {
    return [
      {
        id: 1,
        title: "New Group Implementation",
        pathName: "/planinsightsadmin/grouplist",
      },
    ];
  } else {
    return [];
  }
};
export const AdminLeftMenu = (location) => {
  // if (location.pathname.match("cedargateadmin")) {
  //   return [
  //     {
  //       id: 1,
  //       title: "New Group Implementation",
  //       pathName: "grouplist",
  //       lable: "New Group Implementation",
  //     },
  //   ];
  // } else {
  return [
    // {
    //   id: 0,
    //   title: "Dashboard",
    //   pathName: "/Admin",
    //   lable:"Admin Dashboard"
    // },
    {
      id: 1,
      title: "Region Request",
      pathName: "/Admin/servicerequestview",
      lable: "Hub Region Services",
    },
    {
      id: 2,
      title: "User Details",
      pathName: "/Admin/userdetails",
      lable: "User Detail Services",
    },
    {
      id: 3,
      title: "Carrier Details",
      pathName: "/Admin/carrier",
      lable: "Carrier Detail Services",
    },
    // {
    //   id: 4,
    //   title: "File Type Service",
    //   pathName: "/Admin/filetype",
    //   lable: "File Type Service",
    // },
    {
      id: 5,
      title: "SBAR Access Request",
      pathName: "/Admin/clinicalintakerequest",
      lable: "SBAR Service",
    },
    {
      id: 6,
      title: "Manage Clients",
      pathName: "/Admin/clientaccess",
      lable: "Manage Clients",
    },
    {
      id: 7,
      title: "EmpoweRx Requests",
      pathName: "/Admin/Empowerxaccess",
      lable: "EmpoweRx Requests",
    },
    {
      id: 8,
      title: "Clinical Team Members",
      pathName: "/Admin/ClinicalTeamMembers",
      lable: "Clinical Team Members",
    },
    {
      id: 9,
      title: "Pharmacy Team Members",
      pathName: "/Admin/PharmacyTeamMembers",
      lable: "Pharmacy Team Members",
    },
    {
      id: 10,
      title: "Market Scan Management",
      pathName: "/Admin/MarketScanManagement",
      lable: "Market Scan Management",
    },
  ];
  // }
};

export const HEADER_MENU = [
  {
    id: 1,
    title: "Snapshot 360",
    pathName: "/HUBExperience",
  },
  {
    id: 2,
    title: "Health Insights",
    pathName: "/ACGHealthInsights",
  },
  {
    id: 7,
    title: "Plan Insights",
    pathName: "/planinsights/planinsight",
  },
  // {
  //   id: 8,
  //   title: "Plan Insights Admin",
  //   pathName: "/planinsightsadmin",
  // },
  {
    id: 3,
    title: "EmpoweRx",
    pathName: "/EmpoweRx",
  },
  {
    id: 4,
    title: "Resources",
    pathName: "/resource/resourcecenter",
  },
  {
    id: 5,
    title: "Fusion",
    pathName: "/report",
  },
  {
    id: 6,
    title: "SBAR",
    pathName: "/clinicalIntake",
  },
  {
    id: 9,
    title: "Clinical Consulting",
    pathName: "/clinicalconsulting",
  },
];

export const HEADER_MENU_CLIENT = [
  {
    id: 1,
    title: "EmpoweRx",
    pathName: "/EmpoweRx",
  },
  {
    id: 2,
    title: "Fusion",
    pathName: "/report/sisense",
  },
];

export const ACGHealthInsightsMenu = [
  {
    id: 1,
    title: "Utility Data",
    path: "/ACGHealthInsights/utilitydata",
    pathName: "/utilitydata",
    icon: "mdi:database",
  },
  {
    id: 2,
    title: "Client Data",
    path: "/ACGHealthInsights/clientdata",
    pathName: "/clientdata",
    icon: "mdi:account",
  },
  {
    id: 3,
    title: "Reports",
    path: "/ACGHealthInsights/report&extract",
    pathName: "/report&extract",
    icon: "mdi:file-document",
  },
];

export const ResourcesSubMenu = [
  {
    id: 1,
    title: "Account Structure Change Request",
    pathName: "https://forms.monday.com/forms/6b45269fe322603fb6f7c741e0adcfdf?r=use1",
  },
  {
    id: 2,
    title: "Control Totals",
    pathName:
      "https://forms.monday.com/forms/3f2fa3acb741bbae35b686d33d91d2ee?r=use1",
  },
  {
    id: 3,
    title: "Implementation Form",
    pathName: "https://forms.monday.com/forms/d7a4cefbddf1b45e6021157ddca046a0?r=use1",
  },
  // {
  //   id: 4,
  //   title: "Resource Center",
  //   pathName: "/resource/resourcecenter",
  // },
  {
    id: 5,
    title: "Vendor Change Request",
    pathName: "https://forms.monday.com/forms/a6a2b94d3bf457b144acb3a26bdb58e6?r=use1",
  },
];

export const ClinicalConsultingSubMenu = [
  {
    id: 1,
    title: "AMS",
    path: "/clinicalconsulting/AMS",
    pathName: "/AMS",
    icon: "https://amspredict.com/wp-content/uploads/2023/11/ams_logo.svg",
    hyperlink: "https://predict.mdstrat.com",
  },
  {
    id: 2,
    title: "Epocrates",
    path: "/clinicalconsulting/Epocrates",
    pathName: "/Epocrates",
    icon: "https://www.epocrates.com/epocfavicon.ico?v=2",
    hyperlink:
      "https://www.epocrates.com/login?refernext=https%3A%2F%2Fwww.epocrates.com%2F&location=EOL",
  },
  {
    id: 3,
    title: "MD Pathways",
    path: "/clinicalconsulting/MDPathways",
    pathName: "/MDPathways",
    icon: "https://www.pathway.md/favicons/apple-touch-icon.png",
    hyperlink: "https://www.pathway.md/auth/sign-in",
  },
  {
    id: 4,
    title: "UpToDate",
    path: "/clinicalconsulting/UpToDate",
    pathName: "/UpToDate",
    icon: "https://sso.uptodate.com/app/assets/utd-icon.png",
    hyperlink: "https://sso.uptodate.com/login",
  },
];

export const adminType = [
  {
    id: 1,
    title: "CGT Admin",
    path: "javascript:void(0)",
    icon: "ri:admin-fill",
  },
  {
    id: 2,
    title: "Clinical Admin",
    path: "javascript:void(0)",
    icon: "ri:admin-fill",
  },
  {
    id: 3,
    title: "General Admin",
    path: "javascript:void(0)",
    icon: "ri:admin-fill",
  },
  {
    id: 4,
    title: "Other Admin",
    path: "/admin",
    icon: "ri:admin-fill",
  },
];

export const ServiceRequests = {
  RegionRequest: 1,
  RegardingFile: 2,
  ClinicalIntake: 3,
  EmpoweRx: 4,
  SBARRequest: 5,
  MarketScanMgmt: 6,
};

export const QuestionnaireLeftOption = [
  {
    id: 1,
    title: "Welcome",
    pathName: "/Questionnaire/home",
  },
  {
    id: 2,
    title: "Client and Bidder Information",
    pathName: "/Questionnaire/RFPInitiationandSetUp",
  },
  {
    id: 3,
    title: "Current Plan Design Information",
    pathName: "/Questionnaire/CurrentPlanDesignInformation",
  },
  {
    id: 4,
    title: "Finance & Pricing",
    pathName: "/Questionnaire/FinancePricing",
  },
  {
    id: 5,
    title: "Clinical Programs",
    pathName: "/Questionnaire/ClinicalProgram",
  },
  {
    id: 6,
    title: "Impact Assessments",
    pathName: "/Questionnaire/ImpactAssessments",
  },
  {
    id: 7,
    title: "Additional Questions",
    pathName: "/Questionnaire/AdditionalQuestions",
  },
  {
    id: 8,
    title: "Required File Uploads",
    pathName: "/Questionnaire/RequiredFileUploads",
  },
  {
    id: 9,
    title: "Vendor Reprice",
    pathName: "/Questionnaire/VendorReprice",
  },
  {
    id: 10,
    title: "Summary & Confirmation",
    pathName: "/Questionnaire/SummaryConfirmation",
  },

];
export const TierType = ["Select Tier Type", "3T", "4T"];

export const Size_Rate = {
  Size: ["Select Size", "Small", "Mid", "Large", "Jumbo"],
  Rate: ["Select Rate Type", "Admin", "Comm", "Reins"],
};

export const companySize = [
  "Select Company Size",
  "Small",
  "Mid",
  "Large",
  "Jumbo",
];

export const PlanTypeData = [
  { lable: "Dental", value: 2 },
  { lable: "Medical", value: 1 },
  { lable: "Pharmacy", value: 4 },
  { lable: "Vision", value: 3 },
];

export const Plan = [
  "Select Plan",
  "Unknown",
  "Very Low",
  "Low",
  "Moderate",
  "High",
  "Very High",
];

export const AWPDiscounts = 100;
export const AWPPercentage = "%";
export const dollerIcon = "$";

export const DrugfileType = {
  PBMContract:'PBMContract',
  HospitalHealth:'HospitalHealth',
  PBMClaims:'PBMClaims'
}

export const IAReportSubMenu = [
  {
    id: 1,
    title: "Fusion (Coming Soon)",
    pathName: "#",
  },
  {
    id: 2,
    title: "HUB Health Insights",
    pathName: "/report/sisense",
  },
  {
    id: 3,
    title: "Snapshot 360",
    pathName: "/report/powerbi",
  },

]

export const whiteListURL = [
  "https://infusedanalyticsdev.azurewebsites.net",
  "https://infusedanalyticsqa.azurewebsites.net",
  "https://infusedanalytics.azurewebsites.net",
  "https://infusedanalytics.online"
]
